import { keepPreviousData } from '@tanstack/react-query';
import { useStanQuery } from '@/queries';
import { QUERY_KEYS } from '@/lib';
import { fetchCustomers } from '@/lib/api/customers';
import type { CustomersQueryParams } from '../types/customers.types';

/**
 * Query hook for fetching customers list with pagination and filters
 */
export function useCustomers(params: CustomersQueryParams) {
    return useStanQuery(
        {
            queryKey: [QUERY_KEYS.AUDIENCE, params],
            queryFn: ({ signal }) => fetchCustomers(params, signal),
            placeholderData: keepPreviousData,
            staleTime: 5 * 60 * 1000, // 5 minutes
            meta: {
                error: {
                    sentryMessage: '[AUDIENCE] failed-to-fetch-customers',
                },
            },
        },
        true
    );
}
